import React, { useMemo } from "react";
import { useAppSelector } from "../../redux/hook";
import { TextInfo } from "../../components/text/text-info";
import { P2TextDescription } from "react-bootstrap-common-script";
import { LoanTypeCode } from "../../utils/code-converter";

function ReviewFinancing() {
  const applicationStep2FormData = useAppSelector((state) => state.app.ApplicationStep2Slice.formData);

  const currentLoanType = useMemo(() => {
    return applicationStep2FormData.current_loan_type ? LoanTypeCode.find((item) => item.code === applicationStep2FormData.current_loan_type)?.description : "-";
  }, [applicationStep2FormData.current_loan_type]);

  const newLoanType = useMemo(() => {
    return applicationStep2FormData.new_loan_type ? LoanTypeCode.find((item) => item.code === applicationStep2FormData.new_loan_type)?.description : "-";
  }, [applicationStep2FormData.new_loan_type]);

  return (
    <div style={{ padding: 24 }}>
      <P2TextDescription required color="#000" title="Financing" />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 32,
          marginTop: 32,
        }}
      >
        <TextInfo
          title="Current Loan Type:"
          description={
            <div>
              <p className="m-0">{currentLoanType}</p>
            </div>
          }
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 32,
          marginTop: 32,
        }}
      >
        <TextInfo
          title="New Loan Type:"
          description={
            <div>
              <p className="m-0">{newLoanType}</p>
            </div>
          }
        />
      </div>
    </div>
  );
}

export default ReviewFinancing;